import { AuditFactory, type IAudit } from '@ifs-gcp/core';

import { TEMPLATES_MAP } from '@/constants/templates';
import { ifsLoaders } from '@/hooks/useJsonTemplate';
import { prefetchAllDocumentDefinitions } from '@/queries/get-audit-case-document-definitions';
import { fetchAuditFileForAuditCase } from '@/queries/get-audit-case-file';
import { getAuditCasePermissions } from '@/queries/get-permissions';
import { useUserStore } from '@/store/userStore';
import { createAuditFileBtoa } from '@/utils/createAuditFile';
import { loadAndProcessModules } from '@/utils/processModules';

export type AuditLoaderData = {
  audit: IAudit;
  auditBtoa: string;
};

export async function auditLoader(auditCaseUuid: string): Promise<AuditLoaderData> {
  if (window.location.hash) {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }

  const { userProvider, availableActions, setAvailableActions } = useUserStore.getState();

  const [standards, auditFile, permissions] = await Promise.all([
    loadAndProcessModules(),
    fetchAuditFileForAuditCase(auditCaseUuid),
    getAuditCasePermissions(auditCaseUuid),
  ]);

  const newAvailableActions = { ...availableActions, auditCase: permissions.actions };
  setAvailableActions(newAvailableActions);

  userProvider.permissions = [...newAvailableActions.global, ...newAvailableActions.auditCase];

  const auditFactory = new AuditFactory(ifsLoaders, TEMPLATES_MAP, auditFile.data.modules);
  const audit = await auditFactory.create(auditFile, standards, userProvider);

  await prefetchAllDocumentDefinitions(auditCaseUuid, audit);

  return {
    audit,
    auditBtoa: createAuditFileBtoa(audit),
  };
}
